import Splide from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

function sliderMvBg(): void {
  const sliderIds = ["#mv-slider-1", "#mv-slider-2"];

  sliderIds.forEach((id, index) => {
    const element = document.querySelector(id);
    if (!element) return;

    const splide = new Splide(element as HTMLElement, {
      type: "loop",
      perPage: 1,
      perMove: 1,
      gap: 40,
      arrows: false,
      pagination: false,
      drag: false,
      fixedWidth: 1086,
      autoScroll: {
        speed: index === 0 ? -1 : 1,
        pauseOnHover: false,
        pauseOnFocus: false,
        rewind: false,
      },
    });
    splide.mount({ AutoScroll });
  });
}

export { sliderMvBg };
